import { useState } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../../../contexts/ThemeContext";
import GetStartedModal from "../../../components/feature/GetStartedModal";

export default function ProductHero() {
  const { isDark } = useTheme();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {showModal && <GetStartedModal onClose={() => setShowModal(false)} />}
      <section className={`relative pt-32 pb-20 px-8 lg:px-16 overflow-hidden transition-colors duration-300 ${isDark ? "bg-[#050505]" : "bg-white"}`}>
        <div className={`absolute top-0 right-0 w-[500px] h-[500px] rounded-full blur-3xl pointer-events-none ${isDark ? "bg-white/[0.015]" : "bg-black/[0.015]"}`} />
        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <div className={`inline-flex items-center gap-2 border rounded-full px-4 py-1.5 mb-8 ${isDark ? "bg-white/5 border-white/10" : "bg-black/4 border-black/8"}`}>
                <span className={`font-inter text-xs uppercase tracking-widest ${isDark ? "text-[#888888]" : "text-[#555555]"}`}>
                  The Reseller&apos;s Profit Tool
                </span>
              </div>
              <h1 className={`font-syne font-bold text-6xl lg:text-7xl leading-[1.0] mb-5 ${isDark ? "text-white" : "text-[#111111]"}`}>
                Trackly. <br />
                <span className={`text-transparent bg-clip-text ${isDark ? "bg-gradient-to-r from-[#aaaaaa] to-[#333333]" : "bg-gradient-to-r from-[#555555] to-[#cccccc]"}`}>
                  Know Your <br /> Real Numbers.
                </span>
              </h1>
              <p className={`font-inter text-base leading-relaxed max-w-md mb-10 ${isDark ? "text-[#555555]" : "text-[#666666]"}`}>
                The simple, fast way to calculate true net profit and ROI on every sale. Cards, sneakers, clothes, collectibles — no spreadsheets, no guessing. Just clear, accurate numbers every time.
              </p>
              <div className="flex flex-wrap items-center gap-4">
                <button
                  onClick={() => setShowModal(true)}
                  className={`font-inter font-medium text-sm px-8 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2 ${isDark ? "bg-white text-black hover:bg-[#e8e8e8]" : "bg-[#111111] text-white hover:bg-[#2a2a2a]"}`}
                >
                  Get Early Access Free
                  <i className="ri-arrow-right-line" />
                </button>
                <Link to="/demonstration">
                  <button className={`font-inter text-sm border px-8 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2 ${isDark ? "text-white border-white/15 hover:border-white/30 hover:bg-white/5" : "text-[#111111] border-black/15 hover:border-black/30 hover:bg-black/5"}`}>
                    <i className="ri-play-circle-line" />
                    See How It Works
                  </button>
                </Link>
              </div>
            </div>

            {/* Side: Product highlights */}
            <div className="flex flex-col gap-4">
              {[
                { icon: "ri-calculator-line", title: "Instant profit calculation", desc: "Enter 4 numbers. See real profit in under 2 seconds." },
                { icon: "ri-eye-off-line", title: "Hidden fee auto-detection", desc: "Every platform fee pre-loaded. No manual lookup ever." },
                { icon: "ri-bar-chart-box-line", title: "Daily performance tracking", desc: "Track your margins, volume, and ROI over time." },
                { icon: "ri-store-2-line", title: "10+ platform support", desc: "eBay, StockX, GOAT, Poshmark, Depop, Mercari & more." },
              ].map((item) => (
                <div
                  key={item.title}
                  className={`flex items-start gap-4 border rounded-xl p-4 transition-colors duration-200 cursor-default ${isDark ? "bg-[#0d0d0d] border-white/5 hover:border-white/10" : "bg-[#f8f8f8] border-black/5 hover:border-black/10"}`}
                >
                  <div className={`w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0 ${isDark ? "bg-white/5" : "bg-black/5"}`}>
                    <i className={`${item.icon} text-base ${isDark ? "text-[#555555]" : "text-[#888888]"}`} />
                  </div>
                  <div>
                    <p className={`font-inter text-sm mb-0.5 ${isDark ? "text-white" : "text-[#111111]"}`}>{item.title}</p>
                    <p className={`font-inter text-xs ${isDark ? "text-[#666666]" : "text-[#777777]"}`}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
